export default __webpack_public_path__ + "static/realWorldImg2-5c97aabb3c11d35cbcf89be6226f687d.png";